import React from 'react';

import Twocolorinjecti from './Twocolorinjecti';
import BjmseriesApplicati from './BjmseriesApplicati';
import Equipped from './Equipped';
import Grafibjm from './Grafibjm';



const Petperforminje = () => {
    return (
        <div>
       <Twocolorinjecti />
            <BjmseriesApplicati />
            <Equipped />
            <Grafibjm />
        </div>
    );
};

export default Petperforminje;
